import type { Client } from '~/api/clients/types';

import { Separator } from '~/components';
import { formatVatNumber } from '~/utils/string';

import type { DialogHandles } from '../ClientsTable.hooks';

import { mobileCellStyle, mobileFooterStyle, mobileHeaderStyle, mobileSeparatorStyle } from './clientCell.css';
import { ClientNameCell } from './ClientNameCell';
import { ClientOptionsCell } from './ClientOptionsCell';
import { ClientTypeCell } from './ClientTypeCell';
import { ClientVatCell } from './ClientVatCell';

type Props = {
  client: Client;
  dialogHandles: DialogHandles;
};

export const ClientMobileCell = ({ client, dialogHandles }: Props) => {
  const vatOrOtherNumber = client.vatNumber ? formatVatNumber(client.vatNumber) : client.otherNumber || undefined;

  return (
    <div className={mobileCellStyle}>
      <div className={mobileHeaderStyle}>
        <ClientNameCell client={client} />

        <ClientOptionsCell client={client} dialogHandles={dialogHandles} />
      </div>

      <Separator className={mobileSeparatorStyle} />

      <div className={mobileFooterStyle}>
        <ClientTypeCell type={client.clientType} />

        <ClientVatCell client={client} value={vatOrOtherNumber} />
      </div>
    </div>
  );
};
